<template>
  <div class="sel" :class="{ active: active }">
    <div
      class="btn-wrap"
      @mouseenter="onEnterDom(item)"
      @mouseleave="onLeaveDom(item)"
      @click="choosedCategory(item)"
    >
      <span
        :title="item.categoryName"
        class="ellipsis cursor-pointer item_span"
        >{{ item.categoryName }}</span
      >
      <img src="~@/assets/img/premium/down.png" />
    </div>
    <div class="list">
      <div
        class="leaf-btn-warp"
        v-for="v in row.children || []"
        :key="v.categoryId"
        @click="choosedCategory(v)"
        @mouseenter="onEnterLeafDom(v)"
      >
        <span>
          {{ v.categoryName }}
        </span>
      </div>
      <div
        class="leaf-list"
        v-show="leafRow.children && leafRow.children.length"
      >
        <span
          v-for="k in leafRow.children"
          @click="choosedCategory(k)"
          :key="k.categoryId"
        >
          {{ k.categoryName }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      row: {},
      leafRow: {},
    };
  },
  methods: {
    onEnterLeafDom(res) {
      console.log("leaf enter");
      this.leafRow = res;
    },
    onEnterDom(res) {
      this.row = res;
    },
    onLeaveDom() {
      // this.row = {};
    },
    choosedCategory(v) {
      this.$emit("choosedCategory", v, this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.sel {
  display: inline-block;
  // margin: 0 12px 0 0;
  width: 100%;
  font-size: 0;
  &.active {
    .btn-wrap {
      border-color: #2a54d1;
    }
  }
  &:hover {
    .btn-wrap {
      border-color: #2a54d1;
    }
    img {
      transform: rotate(180deg); /* 旋转180度 */
    }
  }
  &:hover {
    .list {
      display: block;
      transition: all 0.5s ease; /* 添加过渡效果 */
    }
  }
  .btn-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #cccccc;
    padding: 1px 4px 2px 8px;
    border-radius: 8px;
    max-width: 110px;
    img {
      cursor: pointer;
      transition: all 0.5s ease; /* 添加过渡效果 */
    }
  }
  .item_span {
    color: #333333;
    font-size: 14px;
    line-height: 25px;
    padding-right: 4px;
  }
  .list {
    position: absolute;
    left: 0;
    top: 27px;
    z-index: 999;
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #2a54d1;
    border-radius: 6px 12px 12px 12px;
    display: none;
    background: #fff;
    transition: all 0.5s ease; /* 添加过渡效果 */
    text-align: left;
    line-height: 16px;
    span {
      display: inline-block;
      color: #666666;
      font-size: 14px;
      line-height: 14px;
      margin-right: 12px;
      cursor: pointer;
      &:hover {
        color: #2a54d1;
      }
    }
    .leaf-list {
      position: absolute;
      left: 0;
      top: 100%;
      z-index: 9999;
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #2a54d1;
      border-radius: 6px 12px 12px 12px;
      display: none;
      background: #fff;
      transition: all 0.5s ease; /* 添加过渡效果 */
      text-align: left;
      line-height: 16px;
      span {
        display: inline-block;
        color: #666666;
        font-size: 14px;
        line-height: 14px;
        margin-right: 12px;
        cursor: pointer;
        &:hover {
          color: #2a54d1;
        }
      }
    }
    &:hover {
      .leaf-list {
        display: block;
        transition: all 0.5s ease; /* 添加过渡效果 */
      }
    }
  }

  .leaf-btn-warp {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    padding: 1px 4px 2px 8px;
    border-radius: 8px;
  }
}
</style>
